export default "__VITE_ASSET__KZMyGBju__"